import clsx from 'clsx';
import React, { createContext, useContext } from 'react';

const CardVariantContext = createContext();

export const useCardVariant = () => useContext(CardVariantContext);

/**
 * @param {{
 *  variant: "default" | "root" | "card",
 *  contentColumn?: boolean
 * }}
 */
const Card = ({ children, variant = 'default', contentColumn = false, className, ...props }) => {
  return (
    <CardVariantContext.Provider value={variant}>
      <div
        data-content-column={contentColumn || undefined}
        className={clsx(
          {
            'p-4': variant === 'default',
            'text-sm': variant === 'root',
            'py-6': variant === 'root' && !contentColumn,
            'pt-4 pb-6': variant === 'root' && contentColumn,
            'bg-white dark:bg-background rounded drop-shadow m-4 border border-gray-50 dark:border-border last:border-none py-4':
              variant === 'card',
          },
          className,
        )}
        {...props}
      >
        {children}
      </div>
    </CardVariantContext.Provider>
  );
};

export default Card;
